import { useEffect, useState } from 'react';
import { Menu, MenuProps } from 'antd';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import { MailOutlined, UserOutlined, TeamOutlined, UserSwitchOutlined, CloudOutlined, SettingOutlined, MoneyCollectOutlined, DollarCircleOutlined, ApiOutlined, DatabaseOutlined, UnorderedListOutlined, UsergroupAddOutlined, EyeOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { CompanyRole } from '../../Types/CompanyRole';

const LeftMenuSettings = (props: any) => {
    const [current, setCurrent] = useState('1');
    const { user } = useAuth();
    const GetText = TextService.GetText;
    const navigation = useNavigate();
    useEffect(() => {
        setCurrent(props.selected);
    }, []);

    type MenuItem = Required<MenuProps>['items'][number];

    const onClick: MenuProps['onClick'] = (e: any) => {
        navigation("/" + getCurrentLanguage() + "/" + e.key);
    };

    function getItem(
        label: React.ReactNode,
        key?: React.Key | null,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    const items: MenuItem[] = user?.role == CompanyRole.GlobalAdmin ? [
        getItem(GetText("Settings_Account"), 'settings', <UserOutlined />),
        getItem(GetText("Admins_Payments"), 'payments', <DollarCircleOutlined />),
        getItem(GetText("Admins_AdminsTitle"), 'admins', <UserSwitchOutlined />),
        getItem(GetText("PublicSiteForm_Title"), 'publicsite', <CloudOutlined />),
        getItem(GetText("MemberFieldSettings_Title"), 'memberSettings', <SettingOutlined />),
        getItem(GetText("MembershipProducts_Title"), 'membershipProducts', <UsergroupAddOutlined />),
        getItem(GetText("Views_Title"), 'views', <EyeOutlined />),
        getItem(GetText("CustomListSettings_Title"), 'customListsSettings', <DatabaseOutlined />),
        getItem(GetText("EmailTemplates_TemplateTitle"), 'emailTemplates', <MailOutlined />),
        getItem(GetText("AutomaticSending_Title"), 'automaticSending', <ThunderboltOutlined />),
        getItem(GetText("Integrations_IntegrationTitle"), 'integrations', <ApiOutlined />),
        getItem(GetText("Backup_BackupTitle"), 'backup', <DatabaseOutlined />),

    ] : [
        getItem(GetText("Settings_Account"), 'settings', <UserOutlined />),
    ];

    return <Menu
        theme="light"
        onClick={onClick}
        defaultOpenKeys={['sub1']}
        selectedKeys={[current]}
        mode="inline"
        items={items}
    />
};

export default LeftMenuSettings;